import React from "react";
import { buildCardPreview } from "../utils/preview";
import { DEFAULT_TITLE_COLOR } from "../utils/titleColors";

export default function Card({
  title,
  excerpt,
  author,
  date,
  meta,
  icon,
  color,
  onOpen,
  onDelete,
  temp,
  onFolderDragOver,
  onFolderDragLeave,
  onFolderDrop,
  isFolderDropTarget = false,
  variant = "",
}) {
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewZoom, setPreviewZoom] = React.useState(1);
  const preview = buildCardPreview(excerpt);
  const previewText = preview.text || (preview.hasImage ? "Image attachment in this note." : "No preview available for this title yet.");
  const isDashboardCard = variant === "dashboard";
  const closePreview = () => {
    setPreviewOpen(false);
    setPreviewZoom(1);
  };

  return (
    <>
      <article
        className={`note-card ${isDashboardCard ? "note-card-dashboard" : ""} ${temp ? "note-temp" : ""} ${isFolderDropTarget ? "is-folder-drop-target" : ""}`}
        style={{ borderTop: `4px solid ${color || DEFAULT_TITLE_COLOR}` }}
        onDragOver={onFolderDragOver}
        onDragLeave={onFolderDragLeave}
        onDrop={onFolderDrop}
      >
        {isDashboardCard ? (
          preview.imageSrc ? (
            <button
              type="button"
              className="note-card-dashboard-thumbnail"
              onClick={() => {
                setPreviewZoom(1);
                setPreviewOpen(true);
              }}
              aria-label="Open image preview"
            >
              <img src={preview.imageSrc} alt="" loading="lazy" />
            </button>
          ) : (
            <div className="note-card-dashboard-thumbnail is-placeholder" aria-hidden="true">
              <span>{icon || "🗂️"}</span>
            </div>
          )
        ) : null}

        <div className="note-card-header">
          <span className="note-card-tag">{temp ? "Saving" : "Title"}</span>
          {temp ? (
            <span className="saving-badge" aria-live="polite">
              Syncing
              <span className="dots" aria-hidden="true">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
            </span>
          ) : null}
        </div>

        <div className="note-card-body">
          <h3>
            <button
              type="button"
              className="note-card-title-link"
              style={{ color: color || DEFAULT_TITLE_COLOR }}
              onClick={onOpen}
            >
              {icon ? `${icon} ` : ""}{title}
            </button>
          </h3>
          {meta ? <strong className="note-card-subtitle">{meta}</strong> : null}
          {!isDashboardCard && preview.imageSrc ? (
            <button
              type="button"
              className="note-card-preview-media"
              onClick={() => {
                setPreviewZoom(1);
                setPreviewOpen(true);
              }}
              aria-label="Open image preview"
            >
              <img src={preview.imageSrc} alt="" loading="lazy" />
            </button>
          ) : null}
          <div className="note-card-preview">{previewText}</div>
          {preview.hasImage || preview.links.length ? (
            <div className="note-card-preview-meta">
              {preview.hasImage ? <span className="note-preview-pill">Image attachment</span> : null}
              {preview.links.length ? (
                <span className="note-preview-pill note-preview-link-pill" title={`${preview.links.length} link${preview.links.length === 1 ? "" : "s"} in note`}>
                  <span aria-hidden="true">🔗</span>
                  <span>{preview.links.length} link{preview.links.length === 1 ? "" : "s"}</span>
                </span>
      ) : null}
        </div>
          ) : null}
        </div>

        <footer className="note-card-footer">
          <div className="note-card-meta">
            <strong>{author}</strong>
            <span>Updated {date}</span>
          </div>
          <div className="note-card-actions">
            <button className="note-card-open-button" onClick={onOpen}>Open</button>
            <button className="action-link danger" onClick={onDelete}>Delete</button>
          </div>
        </footer>
      </article>

      {previewOpen && preview.imageSrc ? (
        <div className="image-lightbox" role="dialog" aria-modal="true" onClick={closePreview}>
          <div className="image-lightbox-toolbar" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="image-lightbox-control"
              onClick={() => setPreviewZoom((current) => Math.max(1, Number((current - 0.25).toFixed(2))))}
              aria-label="Zoom out image preview"
            >
              -
            </button>
            <span className="image-lightbox-zoom-label">{Math.round(previewZoom * 100)}%</span>
            <button
              type="button"
              className="image-lightbox-control"
              onClick={() => setPreviewZoom((current) => Math.min(3, Number((current + 0.25).toFixed(2))))}
              aria-label="Zoom in image preview"
            >
              +
            </button>
            <button
              type="button"
              className="image-lightbox-close"
              onClick={closePreview}
              aria-label="Close image preview"
            >
              Close
            </button>
          </div>
          <div className="image-lightbox-stage" onClick={closePreview}>
            <img
              className="image-lightbox-media"
              src={preview.imageSrc}
              alt=""
              style={{ transform: `scale(${previewZoom})` }}
              onClick={closePreview}
            />
          </div>
        </div>
      ) : null}
    </>
  );
}
